export default __webpack_public_path__ + "static/media/magon-2-bathroom-min.26603b3d.jpg";